module.exports = __webpack_public_path__ + "static/img/ic-pr.dcb7b30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/ic-pr.png
// module id = eg18
// module chunks = 0